import { useEffect, useState } from "react";
import { Sun, Snowflake } from "lucide-react";
import ForestBackdrop from "@/components/ForestBackdrop";

const STORAGE_KEY = "mkb-season";

export default function SeasonalBackdrop() {
  const [season, setSeason] = useState(() => {
    if (typeof window === "undefined") return "summer";
    return localStorage.getItem(STORAGE_KEY) === "winter" ? "winter" : "summer";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, season);
  }, [season]);

  const toggle = () => setSeason((s) => (s === "summer" ? "winter" : "summer"));
  const isWinter = season === "winter";

  return (
    <>
      <ForestBackdrop variant={season} />
      <button
        onClick={toggle}
        aria-label={isWinter ? "Switch to summer forest" : "Switch to winter forest"}
        data-testid="season-toggle"
        title={isWinter ? "Bring back the sunshine" : "Let it snow"}
        style={{
          position: "fixed",
          right: "1.25rem",
          bottom: "1.25rem",
          zIndex: 60,
          width: "3.25rem",
          height: "3.25rem",
          borderRadius: "9999px",
          border: "1.5px solid rgba(180,159,255,0.5)",
          background: isWinter
            ? "linear-gradient(135deg, #DCEEFB 0%, #FFFFFF 100%)"
            : "linear-gradient(135deg, #FFD93D 0%, #FF8C42 100%)",
          color: isWinter ? "#2D3055" : "#2D3055",
          boxShadow: "0 10px 26px rgba(45,48,85,0.20)",
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "transform 0.25s ease-out, box-shadow 0.25s ease-out",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = "translateY(-2px) scale(1.05)";
          e.currentTarget.style.boxShadow = "0 14px 32px rgba(45,48,85,0.28)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = "";
          e.currentTarget.style.boxShadow = "0 10px 26px rgba(45,48,85,0.20)";
        }}
      >
        {isWinter ? <Snowflake size={22} strokeWidth={2.2} /> : <Sun size={22} strokeWidth={2.2} />}
      </button>
    </>
  );
}
